
// Vendor Base Components
import './vendor/jquery-3.3.1/main.js';
import './vendor/bootstrap-4.3.1/main.js';
import './vendor/noty-3.2/noty.js';
import './vendor/sticky-sidebar-3.2/main.js';

// Shared Components
import './components/jquery-swipe/main.js';
import './components/scroll-top/main.js';
import './components/current-url/main.js';
import './components/animate/main.js';
import './components/ajax-modal/main.js';
import './components/window-popup/main.js';
import './components/confirm-action/main.js';


import './module/js/sidebar';
import './module/js/mobile-top-bar';
import './module/js/topmenu';

/** Vendor **/
import './vendor/numscroller/main.js';
import './vendor/owl-carousel/main.js';


// Entry
import './module/main.js';